<div class="px-15">
    <section id="overall-summaries" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title g-just-flex">
                    <div class="me-15">Healthcare Admin Dashboard</div>
                </div>
                <div class="subtitle">
                    Real-time patient check-ins and registration overview.
                </div>
            </div>

            <div class="controls g-just-flex gap-15" [scrolld]="'card'">
                <div class="rounded-icon-wrapper prev-btn">
                    <mat-icon>chevron_left</mat-icon>
                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-30">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                
                <div class="card appointment-card" (click)="navigateToRegistration()">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>person_add</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2">Pending Registrations</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Patient registrations awaiting approval.">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">{{ (pendingRegistrations$ | async) || 0 }}</div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2 justify-content-start">
                            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">how_to_reg</mat-icon> Needs approval
                        </div>
                    </div>
                </div>

                <div class="card appointment-card" (click)="navigateToActivePatients()">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>groups</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2">Total Active Patients</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Approved patients where active is true, including deceased records.">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">{{ (activePatients$ | async) || 0 }}</div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2 justify-content-start">
                            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">folder_shared</mat-icon> View approved
                        </div>
                    </div>
                </div>

                <div class="card appointment-card" (click)="navigateToPharmacyWalkIns()">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>local_pharmacy</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2">Pharmacy Walk-ins</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Active pharmacy walk-in patients. Opens approved patient registration records.">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">{{ (pharmacyWalkIns$ | async) || 0 }}</div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2 justify-content-start">
                            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">filter_alt</mat-icon> View walk-ins
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>

    <section id="receptionist-quick-actions" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title g-just-flex">
                    <div class="me-15">Reception Actions</div>
                </div>
            </div>

            <div class="controls g-just-flex gap-15" [scrolld]="'action-button'">
                <div class="rounded-icon-wrapper prev-btn">
                    <mat-icon>chevron_left</mat-icon>
                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-30">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                <div class="action-button" (click)="navigateToRegistration()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>person_add_alt</mat-icon>
                    </div>
                    <span>Approve Patients</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>

                <div class="action-button" (click)="navigateToApprovedPatients()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>archive</mat-icon>
                    </div>
                    <span>Archive Patient</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>
    </section>

    <section id="appointments-registry" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
     
            </div>
        </div>

        <div class="section-wrapper pt-20">
              <app-upcoming-activities></app-upcoming-activities>
        </div>
    </section>
</div>
